import { Grid, Typography } from '@mui/material';

export interface TooltipTitleProps {
    label: string;
    description?: string;
}

export const TooltipTitle = ({ label, description }: TooltipTitleProps) => (
    <Grid container flexDirection="column" alignItems="flex-start">
        <Grid item xs="auto">
            <Typography fontSize="14px" fontWeight={700} color="#FFFFFF">
                {label}
            </Typography>
        </Grid>
        <Grid item xs="auto">
            <Typography fontSize="14px" fontWeight={300} color="#FFFFFF">
                {description}
            </Typography>
        </Grid>
    </Grid>
);
